'use client';

import * as React from 'react';

import { useTranslations } from 'next-intl';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

// Types
type T_Race = 'african' | 'arabic' | 'asian' | 'caucasian' | 'indian';

type T_RaceTabsProps = {
  activeRace: T_Race;
  onRaceChange: (race: T_Race) => void;
  races: { category: T_Race; label: string }[];
};

export function RaceTabs({ activeRace, onRaceChange, races }: T_RaceTabsProps) {
  const t = useTranslations('editProfile.avatar.races');

  return (
    <Tabs
      value={activeRace}
      onValueChange={value => onRaceChange(value as T_Race)}
      className="w-full min-w-max border-b-1"
    >
      <TabsList className="flex w-full bg-transparent p-0 justify-between  md:justify-center lg:justify-between ">
        {races.map(race => (
          <TabsTrigger
            key={race.category}
            value={race.category}
            className="  cursor-pointer md:px-4 md:py-2.5 px-2.5 py-2 text-base font-normal leading-normal
                         data-[state=active]:border-b-[3px] data-[state=active]:border-b-primary
                         data-[state=active]:text-primary data-[state=active]:font-bold
                         data-[state=inactive]:text-muted bg-transparent border-b-0 rounded-none
                         data-[state=active]:bg-transparent data-[state=inactive]:bg-transparent
                         focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            {t(race.category)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
